/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Rep_NoteInputs */

const en_us2_progress_extra_rep_note = /** @type {(inputs: Progress_Extra_Rep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The zones overlap: strength and size grow in almost all of them. What matters most is ending a set close to failure.`)
};

const pt_br2_progress_extra_rep_note = /** @type {(inputs: Progress_Extra_Rep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As faixas se sobrepõem: força e massa crescem em quase todas elas. O que mais pesa é terminar a série perto da falha.`)
};

const es_419_progress_extra_rep_note = /** @type {(inputs: Progress_Extra_Rep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los rangos se superponen: la fuerza y el músculo crecen en casi todos. Lo que más importa es terminar la serie cerca del fallo.`)
};

const pt_pt2_progress_extra_rep_note = /** @type {(inputs: Progress_Extra_Rep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os intervalos sobrepõem-se: a força e a massa crescem em quase todos. O que mais pesa é terminar a série perto da falha.`)
};

const fr_fr2_progress_extra_rep_note = /** @type {(inputs: Progress_Extra_Rep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les zones se chevauchent : la force et le volume musculaire progressent dans presque toutes. Le plus important est de finir une série près de l'échec.`)
};

const de_de2_progress_extra_rep_note = /** @type {(inputs: Progress_Extra_Rep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bereiche überlappen: Kraft und Muskelmasse wachsen in fast allen. Am wichtigsten ist, einen Satz nah am Muskelversagen zu beenden.`)
};

const it_it2_progress_extra_rep_note = /** @type {(inputs: Progress_Extra_Rep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fasce si sovrappongono: forza e massa crescono in quasi tutte. Ciò che conta di più è chiudere la serie vicino al cedimento.`)
};

/**
* | output |
* | --- |
* | "The zones overlap: strength and size grow in almost all of them. What matters most is ending a set close to failure." |
*
* @param {Progress_Extra_Rep_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_rep_note = /** @type {((inputs?: Progress_Extra_Rep_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Rep_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_rep_note(inputs)
	if (locale === "es-419") return es_419_progress_extra_rep_note(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_rep_note(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_rep_note(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_rep_note(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_rep_note(inputs)
	return en_us2_progress_extra_rep_note(inputs)
});
export { progress_extra_rep_note as "progress-extra.rep_note" }